var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dragess",attrs:{"id":'drage' + _vm.taskId + _vm.uuid},on:{"click":_vm.reset}},[_c('svg')])}
var staticRenderFns = []

export { render, staticRenderFns }